import { createContext, useContext, useState, useEffect } from 'react';
import API from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('meddivo_token');
    const savedUser = localStorage.getItem('meddivo_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        API.get('/auth/me').then(res => {
          setUser(res.data);
          localStorage.setItem('meddivo_user', JSON.stringify(res.data));
        }).catch(() => {
          localStorage.removeItem('meddivo_token');
          localStorage.removeItem('meddivo_user');
          setUser(null);
        }).finally(() => setLoading(false));
      } catch {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    localStorage.setItem('meddivo_token', res.data.token);
    localStorage.setItem('meddivo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (data) => {
    const res = await API.post('/auth/register', data);
    localStorage.setItem('meddivo_token', res.data.token);
    localStorage.setItem('meddivo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('meddivo_token');
    localStorage.removeItem('meddivo_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
